/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trimbleProvisioningControllerListRecords } from "./trimbleProvisioningControllerListRecords";
import { trimbleProvisioningControllerSyncStatus } from "./trimbleProvisioningControllerSyncStatus";

export function trimbleProvisioningService() {
  return { trimbleProvisioningControllerListRecords, trimbleProvisioningControllerSyncStatus }
}